import { FunctionComponent, useCallback, ChangeEvent } from 'react'
import { WidgetProps } from '@rjsf/core'
import { RadioGroup, Option } from '@dxp-module/common'
import radioGroupStyles from './radioGroup.styles'

const RadioGroupWidget: FunctionComponent<WidgetProps> = props => {
  const { id, defaultValue, value, onChange, options, schema, label } = props
  const { type } = schema
  const styles = radioGroupStyles({})

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (type === 'boolean') {
        return onChange(event.target.value === 'true')
      }
      return onChange(event.target.value)
    },
    [type]
  )

  const optionList = options?.enumOptions

  if (!optionList) {
    return null
  }

  return (
    <RadioGroup
      id={id}
      label={label}
      defaultValue={defaultValue}
      value={value}
      classes={styles}
      options={optionList as Option[]}
      onChange={handleChange}
    />
  )
}

export default RadioGroupWidget
